<template>
  <span v-if="time"> {{ time }} </span>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useCartStore } from "@/store/cart.ts";
const cartStore = useCartStore();

const time = computed(() => {
  if (!cartStore.timeLeft) return;

  const ms = cartStore.timeLeft;

  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const hours = Math.floor(ms / (1000 * 60 * 60));

  return [hours, minutes, seconds].map((unit) => String(unit).padStart(2, "0")).join(":");
});
</script>
